import React, { useContext } from 'react';
import { Notification } from '@oneaudi/unified-web-components';
import { UniversalStateContext } from '../context/UniversalStateContext';

interface ErrorMessageProps {
  onClose: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ onClose }) => {
  const context = useContext(UniversalStateContext);
  if (!context) {
    return null;
  }
  const { i18nTexts } = context;
  const errorMsg = i18nTexts.streamError;
  return (
    <Notification
      closeButton={{
        ariaLabel: 'Close Notification',
        onClick: onClose,
      }}
      copy={errorMsg}
      icon="break"
    />
  );
};

export default ErrorMessage;
